/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import Select from './Select';
import config from '../../../../config';
import {aspectRatios, experimentalAspectRatios} from '../data/AspectRatios';

export const AspectRatioSelect = ({defaultValue, onChange, disabled}) => {
  const aspectRatioOptions = config.enableExperimentalFeatures ? [...aspectRatios, ...experimentalAspectRatios] : aspectRatios;

  aspectRatioOptions.sort((resolutionA, resolutionB) => {
    return resolutionA.index - resolutionB.index;
  });

  const options = aspectRatioOptions.map(resolution => ({
    value: resolution.value,
    label: resolution.name
  }));

  return (
    <Select
      defaultValue={defaultValue}
      onChange={onChange}
      disabled={disabled}
      options={options}
    />
  );
};

AspectRatioSelect.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};